import { createAsyncThunk, createSlice, isAnyOf } from "@reduxjs/toolkit";

import { triplePSDatasource } from "../../datasource";
import {
  APIResult,
  emptyAPIResult,
  loadingAPIResult,
  successAPIResult,
  errorAPIResult,
} from "../../lib/redux";
import { Pricing } from "../../models";
import { logout } from "../Auth/authSlice";

export interface PricingState {
  getPricing: APIResult<Pricing>;
  updatePricing: APIResult<Pricing>;
  pricing?: Pricing;
}

const initialState: PricingState = {
  getPricing: emptyAPIResult(),
  updatePricing: emptyAPIResult(),
};

export const getPricing = createAsyncThunk("pricing/getPricing", async () => {
  return triplePSDatasource.getPricing();
});

export const updatePricing = createAsyncThunk(
  "pricing/updatePricing",
  async (pricing: Pricing) => {
    return triplePSDatasource.updatePricing(pricing);
  }
);

export const pricingSlice = createSlice({
  name: "pricing",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getPricing.pending, (state) => {
        state.getPricing = loadingAPIResult();
      })
      .addCase(getPricing.fulfilled, (state, action) => {
        state.getPricing = successAPIResult(action.payload);
        state.pricing = action.payload;
      })
      .addCase(getPricing.rejected, (state, action) => {
        state.getPricing = errorAPIResult(action.error);
      })
      .addCase(updatePricing.pending, (state) => {
        state.updatePricing = loadingAPIResult();
      })
      .addCase(updatePricing.fulfilled, (state, action) => {
        state.updatePricing = successAPIResult(action.payload);
        state.pricing = action.payload;
      })
      .addCase(updatePricing.rejected, (state, action) => {
        state.updatePricing = errorAPIResult(action.error);
      })
      .addMatcher(isAnyOf(logout), (state) => {
        state.getPricing = emptyAPIResult();
        state.updatePricing = emptyAPIResult();
        state.pricing = undefined;
      });
  },
});

export default pricingSlice.reducer;
